import { useQuery } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { useDriverStateV2 } from './useDriverStateV2';
import { getLimits, BillingLimitsData } from '../api/billing';

export type { BillingLimitsData };

export const billingLimitsQueryKey = (companyId?: string) =>
  ['billing-limits', companyId] as const;

export const useBillingLimits = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const { driver } = useDriverStateV2();

  return useQuery({
    queryKey: billingLimitsQueryKey(driver?.companyId),
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      if (!driver?.companyId) {
        throw new Error('Company ID not available');
      }
      return getLimits(token, driver.companyId);
    },
    enabled: !!driver?.companyId,
    staleTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 24 * 60 * 60 * 1000,
    refetchIntervalInBackground: true,
  });
};
